'use strict';

var React = require('react');

var SvgShieldNoneIcon = function SvgShieldNoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.506 3.973a15.26 15.26 0 0 1-1.059-.775l-.354-.283a1.75 1.75 0 0 0-2.186 0l-.317.253a15.25 15.25 0 0 1-3.217 1.976l-.847.384a1.71 1.71 0 0 0-1.01 1.628c.083 1.865.507 3.422 1.096 4.71l1.146-1.145c-.401-1.025-.681-2.228-.744-3.632-.003-.068.037-.152.133-.195l.846-.385a16.75 16.75 0 0 0 3.534-2.17l.317-.253a.25.25 0 0 1 .312 0l.354.283c.298.238.603.466.916.683l1.08-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.553 14.046a.75.75 0 0 0 1.066 1.056l.64-.64a11.092 11.092 0 0 0 2.99 2.496 1.533 1.533 0 0 0 1.502 0c1.352-.753 5.454-3.55 5.734-9.783a1.71 1.71 0 0 0-1.002-1.623l-.215-.1.604-.603a.75.75 0 1 0-1.06-1.06l-10.254 10.252a2.489 2.489 0 0 1-.005.005Zm5.426 1.602a9.544 9.544 0 0 1-2.655-2.251l6.814-6.814.717.33a.213.213 0 0 1 .131.195c-.246 5.489-3.827 7.906-4.965 8.54a.043.043 0 0 1-.02.006c-.005 0-.012 0-.022-.006Z"
  }));
};
SvgShieldNoneIcon.displayName = "ShieldNoneIcon";

exports.SvgShieldNoneIcon = SvgShieldNoneIcon;
